// The global top header bar was removed for the Command Deck redesign.
// Navigation + identity live in the Sidebar (incl. the Profile nav item),
// and each redesigned page carries its own header with page-specific actions
// (e.g. "Post new job"). This stub keeps existing `<Header />` usages valid.
const Header = () => null;

export default Header;
